import { redirectTo } from 'omni-package-react-core';
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StyledButton } from '../AuthenticationFactors.styles';
import Constants from '../../../Constants';

export interface UpdateFactorsButtonProps { }

const UpdateFactorsButton: FC<UpdateFactorsButtonProps> = () => {
  const { t } = useTranslation('AuthenticationFactors');
  const navigate = useNavigate();

  const handleUpdateFactors = useCallback(() => {
    redirectTo(Constants.MfaPasswordStepSegment, navigate);
  }, [navigate]);

  return (
    <StyledButton
      data-testid="update-factors-button"
      outline
      onClick={handleUpdateFactors}
    >
      {t('updateButton')}
    </StyledButton>
  );
};

export default UpdateFactorsButton;
